
/*
"process": {
	"env": {
	  "NODE_ENV": "development"
	  "NODE_ENV": "production"
	}
}*/
//process.env.NODE_ENV = 'development';
//process.env.NODE_ENV = 'production';

//import * as $ from './node_modules/jquery/dist/jquery.min.js';
//import * as $ from 'jquery';
//import './node_modules/jquery/dist/jquery.min.js';
//window.$ = $;
//window.jQuery = $;

//import './node_modules/jquery-qrcode/jquery.qrcode.min.js';






//console.log(window.bootstrap);
//console.log(window.bootstrap.Dropdown);
//console.log(Popper);
//import transitions from "bootstrap";
//window.transitions = transitions;


/*
import * as tinymce from './node_modules/tinymce/tinymce.min.js';
//import * as tinymce from 'tinymce';
import * as tinymce_theme from './node_modules/tinymce/themes/silver/index.js';
import * as tinymce_icons from './node_modules/tinymce/icons/default/index.js';
import './node_modules/tinymce/skins/content/default/content.css';
import './node_modules/tinymce/skins/ui/oxide/content.css';
import './node_modules/tinymce/skins/ui/oxide/skin.css';
*/

//import Stackedit from 'stackedit-js';
//window.Stackedit = Stackedit;

//import woofmark from 'woofmark';
//window.woofmark = woofmark;

//import megamark from 'megamark';
//window.megamark = megamark;

//import domador from 'domador';
//window.domador = domador;

// --

/*
import { Editor } from './tui/apps/editor/dist/esm/index.js';
//import { Editor } from './tui/apps/editor/dist/toastui-editor.js';
//import { Editor } from './tui/editor/dist/toastui-editor.js';
//import Editor from './tui/editor/dist/esm/index.js';
//import { Editor } from './tui/editor/dist/cdn/toastui-editor-all.js';
//import Editor from './tui/editor/dist/cdn/toastui-editor-all.js';

//import editor_uml from '@toast-ui/editor-plugin-uml';
//import editor_webnode from '@toast-ui/editor-plugin-web-node';

window.toastui = { };
window.toastui.Editor = Editor;
*/
/*window.toastui = {
	//editor_uml: editor_uml,
	//editor_webnode: editor_webnode,
	Editor: Editor
};*/
//console.log('window.Editor', window.toastui);

import Split from 'split.js';
window.Split = Split;

//@import 'custom';
//@import '~bootstrap/scss/bootstrap';
//++ import './bootstrap_style.scss'
//++++import './node_modules/bootstrap-icons/font/bootstrap-icons.css';
//import 'bootstrap-icons';

//import Store from './drdocstore.js';
//window.Store = Store;
import DrDocWeb from './drdocweb.js';
window.DrDocWeb = DrDocWeb;
//import Node from './drdocnode.js';
//window.Node = Node;
import DrDoc from './drdoc.js';
window.DrDoc = DrDoc;
//import './base32.js'

import DrawConnection from './draw-connection-line.js';
window.DrawConnection = DrawConnection;

//import './script.js'

// Requires: DrDocWeb, Node, DrDoc

DrDoc.Init();

document.addEventListener('DOMContentLoaded', function(e) {
	DrDocWeb.EventFire(document, 'NodeLoaded');
	if (window.DrawConnection !== undefined)
		DrawConnection.init();
});



/*window.tinymce = tinymce;
window.tinymce_theme = tinymce_theme;
window.tinymce_icons = tinymce_icons;*/
